<template>
  <div>
    <div v-if="!isNew" class="text-end">
      <button class="btn btn-light mb-2" @click="()=>{showAuditModal=true;}">Audit</button>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <div class="row mb-3">
              <div class="col-sm-3 text-secondary">
                Title:
              </div>
              <div class="col-sm-6">
                <input type="text" class="form-control" :class="error.title && 'control-error'" v-model="dataObj.title" />
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3 text-secondary">
                Detail:
              </div>
              <div class="col-sm-6">
                <div>
                  <quillEditor
                  v-model="dataObj.detail"
                  ref="myQuillEditor"
                  :options="editorOption"
                  >
                  </quillEditor>
                </div>
                <!-- <div>
                  <textarea class="form-control" :class="error.detail && 'control-error'" v-model="dataObj.detail" style="height:350px;">
                  </textarea>
                </div> -->
              </div>
            </div>
            <div class="row mb-3">
              <div class="col-sm-3 text-secondary">Active:</div>
              <div class="col-sm-3">
                <input type="checkbox" v-model="dataObj.status" />
              </div>
            </div>
          </div>
        </div>
        <button class="btn btn-secondary m-1 float-end" @click="clickCancel">Cancel</button>
        <button class="btn btn-success m-1 float-end" @click="clickSave">Save</button>
        <button v-if="!isNew" class="btn btn-danger m-1" @click="confirmRemove">Delete</button>
      </div>
    </div>
    <ModalDiaglog size="xl" :show="showAuditModal" :onClose="()=>{showAuditModal=false}" :hasHeader="false" :showSubmitBtn1="false">
      <div v-if="showAuditModal">
        <AuditLog 
        :timezone="timezone" 
        tablename="News Announcement" 
        :primarykey="oid" 
        :categories="[]"
        :defaultCategory="'All'" 
        :basicLogInfoOid="oid" 
        :basicLogInfoUrl="basicLogInfoUrl" 
        />
      </div>
    </ModalDiaglog>      
  </div>
</template>

<script>
import 'quill/dist/quill.snow.css';
import { quillEditor } from 'vue-quill-editor';
import apiUrl from '@/common/apiurl';
import api from '@/common/api';
import _ from 'lodash';
import AuditLog from '@/components/custom/AuditLog';
import ModalDiaglog from '@/components/custom/ModalDiaglog';
import * as Forms from '@/components/custom/forms';

export default {
  name: 'AddEditNewsAnnouncement',
  components: {
    AuditLog,
    ModalDiaglog,
    ...Forms,
    quillEditor
  },

  props: {

  },

  data() {
    return {
      basicLogInfoUrl: apiUrl.roles.getBasicLogInfo,
      oid: 0,
      isNew: true,
      confirmObj: {},
      dataObj: {},
      timezone: api.TIMEZONE,
      alertCounter: 0,
      alertMessage: "",
      permissions: [],
      groupPermissions: {},
      showAuditModal: false,
      corporateTypes: [],

      error: {},
      editorOption: {}
    };
  },
  destroyed() {
    this.clearBreadcrumb();
  },
  beforeMount() {
    let passedId = this.$route.params.id;
    if (passedId && passedId > 0) {
      this.oid = parseInt(passedId);
      this.isNew = false;
    }
  },
  mounted() {

    let pageName = this.isNew ? 'New News Announcement' : 'Edit News Announcement';
    this.setBreadcrumb([
      { name: 'NewsAnnouncements', url: '/newsannouncements' }, { name: pageName }
    ]);

    // if (this.isNew) {
    //   this.dataObj.isActive = true;
    // }
    if (this.oid > 0) {
      this.getData();
    } 

  },

  methods: {
    getData() {
      let url = apiUrl.newsAnnouncements.getByOid + '/' + this.oid
      api.regularGet(url, null).then((response) => {
        this.dataObj = response.data;
      });
    },
    
    getPermissions() {
      api.getAllPermissions(null, this.$store.state.token).then((response) => {
        if (response.status == 200) {
          this.permissions = response.data;
          this.permissions = this.permissions.sort(x => x.headerGroup);

          for (let i = 0; i < this.permissions.length; i++) {

            //render checked
            if (!this.isNew && this.dataObj.permissions) {
              let per = this.dataObj.permissions.find(x => x.oid == this.permissions[i].oid)
              if (per)
                this.permissions[i].checked = true;
            }
          }
          let headerList = _.uniqBy(this.permissions, "headerGroup").map(x => x.headerGroup);
          this.groupPermissions = [];
          for (let h = 0; h < headerList.length; h++) {
            let obj = {
              header: headerList[h],
              permissions: this.permissions.filter(x => x.headerGroup == headerList[h])
            };
            this.groupPermissions.push(obj);
          }
        }
      });
    },
    clickSave() {
      if (!this.validate())
        return;
      let subUrl = '';
      if (this.isNew) {
        subUrl = apiUrl.newsAnnouncements.insert;
      }
      else {
        subUrl = apiUrl.newsAnnouncements.update;
      }

      this.showLoadingScreen();
      console.log(this.dataObj);
      console.log(this.$store.state)
      api.regularPost(subUrl, this.dataObj, this.$store.state.token).then((response) => {
        this.hideLoadingScreen();
        if (response.status == 200) {
          this.showMessage("Successfully saved.", "success");
          this.$router.push({ name: "ManageNewsAnnouncements" });
        }
        else if (response.status == 400 || response.errorText.response.status == 400) {
          this.showMessage(response.errorText.response.data.message, "error");
        }
        else {
          this.showMessage(window.message.unable_proceed, "error");
        }
      });

    },
    clickCancel() {
      this.$router.push({ name: "ManageNewsAnnouncements" });
    },
    validate() {
      let isValid = true;
      Object.keys(this.error).forEach(k => this.error[k] = false);

      if (!this.dataObj.title) { this.error.title = true; isValid = false; }

      this.$forceUpdate();
      return isValid;
    },
    showErrorMessage(msg) {
      this.alertCounter = 5;
      this.alertMessage = msg;
    },
    confirmRemove() {
      this.showConfirmDiaglog(
        {
          show: true,
          message: 'Are you sure to remove ' + this.dataObj.title + '?',
          submitFunction: () => {
            api.regularPost(apiUrl.newsAnnouncements.delete, this.dataObj, this.$store.state.token).then((response) => {
              if (response.status == 200) {
                this.showMessage("Successfully Deleted.", "success");
                this.$router.push({ name: "ManageNewsAnnouncements" });
              }
              else if (response.status == 400 || response.errorText.response.status == 400) {
                this.showMessage(response.errorText.response.data.message, "error");
              }
              else {
                this.showMessage(window.message.newsannouncement.unable_delete, "error");
              }
            });
          }
        });
    },
    showAudit() {
      this.showAuditDialog(true);
    }
  }
}
</script>
